import $ from 'jquery';
import Swiper, { Lazy } from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

/* eslint-disable */
/**
 * hero section selector
 * @type {string}
 */
const heroEl = '.hero';

/**
 * hero section's container selector
 * @type {string}
 */
const containerEl = '.hero__container';

/**
 * slide's selector
 * @type {string}
 */
const slideEl = '.hero__slide';

/**
 * active slide's selector
 * @type {string}
 */
const slideActiveEl = '.swiper-slide-active';

/**
 * slide preloader class
 * @type {string}
 */
const slidePreloaderClass = 'c-slide-preloader';

/**
 * slider nav prev
 * @type {string}
 */
const navPrevEl = '.hero__nav--prev';

/**
 * slider nav next
 * @type {string}
 */
const navNextEl = '.hero__nav--next';

/**
 * swipers
 * @type {Array}
 */
const swipers = [];

$(window).on('load resize', function () {
  init();
});

/**
 * Init all hero sliders
 * @return void
 */
function init() {
  $(heroEl).each(function (i, item) {
    initHero(item);
  });
}

/**
 * Init hero slider
 * @return bool|void
 */
function initHero(slider) {
  if (!$(slider).find(containerEl)[0]) {
    return false;
  }

  let oneSlide = ($(slider).find($(slideEl)).length <= 1);

  if (oneSlide) {
    $("." + slidePreloaderClass).remove();
    return false;
  }

  let swiper = new Swiper($(slider).find($(containerEl))[0], {
    loop: false,
    init: false,
    spaceBetween: 0,
    slidesPerView: 1,
    speed: 300,
    modules: [Lazy, HideOffscreenSlides],
    lazy: {
      loadPrevNext: true,
      preloaderClass: slidePreloaderClass,
      preloadImages: false,
    },
    navigation: {
      nextEl: navNextEl,
      prevEl: navPrevEl,
    },
    on: {
      init: function () {
        updateSlideFocus(swiper);
      },
      slideChangeTransitionEnd: function () {
        updateSlideFocus(swiper);
      },
    },
  });

  swiper.init();
  swipers.push(swiper);
}

/**
 * Update tabindex
 * @param swiper
 * @return void
 */
function updateSlideFocus(swiper) {
  $(swiper['el']).find($('a')).prop('tabindex', -1);
  $(swiper['el']).find($(slideActiveEl)).find($('a')).prop('tabindex', 0);
}

/* eslint-enable */

(function () {
  const isIphone = /iPhone/.test(navigator.userAgent);
  if (!isIphone) return;

  const updateHeroState = () => {
    const isPortrait = window.matchMedia('(orientation: portrait)').matches;
    const doc = document.documentElement;

    if (isPortrait) {
      doc.style.setProperty('--ios-hero-height', `${window.screen.height}px`);
      doc.classList.add('is-iphone-portrait');
    } else {
      doc.classList.remove('is-iphone-portrait');
      doc.style.removeProperty('--ios-hero-height');
    }
  };

  window.addEventListener('resize', updateHeroState);
  window.addEventListener('orientationchange', updateHeroState);
}());
